/**
 * 通用js方法封装处理
 * Copyright (c) 2019
 */
import {serverUrl} from '@/utils/request';

const baseURL = serverUrl;

//字符串转Date
export function strToDate(str){
    return new Date(str.replace(/-/g,'/'))
}

// 中国标准时间转换为 yyyy-MM-dd  HH:MM:SS
export function changeToCurrentDay(time) {
    let now;
    if(time){
        now = new Date(time);
    }else{
        now = new Date()
    }

    let nowYear = now.getFullYear();
    let nowDay = now.getDate(); // 当前日
    let nowMonth = now.getMonth() + 1; // 当前月
    nowMonth = checkTime(nowMonth);
    nowDay = checkTime(nowDay);
    let nowHours = now.getHours(); // 当前小时
    let nowMinutes = now.getMinutes(); // 当前分钟
    let nowSeconds = now.getSeconds(); // 当前秒
    nowHours = checkTime(nowHours);
    nowMinutes = checkTime(nowMinutes);
    nowSeconds = checkTime(nowSeconds);
    return `${nowYear}-${nowMonth}-${nowDay} ${nowHours}:${nowMinutes}:${nowSeconds}`;
}

// 日期格式化
export function parseTime(time, pattern) {
    if (arguments.length === 0 || !time) {
        return null;
    }
    const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}';
    let date;
    if (typeof time === 'object') {
        date = time;
    } else {
        if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
            time = parseInt(time);
        } else if (typeof time === 'string') {
            time = time
                .replace(new RegExp(/-/gm), '/')
                .replace('T', ' ')
                .replace(new RegExp(/\.[\d]{3}/gm), '');
        }
        if (typeof time === 'number' && time.toString().length === 10) {
            time = time * 1000;
        }
        date = new Date(time);
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay(),
    };
    const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key];
        // Note: getDay() returns 0 on Sunday
        if (key === 'a') {
            return ['日', '一', '二', '三', '四', '五', '六'][value];
        }
        if (result.length > 0 && value < 10) {
            value = '0' + value;
        }
        return value || 0;
    });
    return time_str;
}

// 获取当前年份
export function getCurrentYear() {
    var now = new Date(); // 当前日期
    var nowYear = now.getFullYear();
    return `${nowYear}`;
}

// 获取当前年月
export function getCurrentYearMonth() {
    var now = new Date(); // 当前日期
    var nowYear = now.getFullYear();
    var nowMonth = checkTime(now.getMonth() + 1); // 当前月
    return `${nowYear}-${nowMonth}`;
}

// 获取当前月
export function getCurrentMonth() {
    var now = new Date(); // 当前日期
    var nowMonth = now.getMonth() + 1; // 当前月
    return nowMonth;
}

// 当前时间
export function getCurrentTime() {
    var now = new Date(); // 当前日期
    var nowHours = now.getHours(); // 当前小时
    var nowMinutes = now.getMinutes(); // 当前分钟
    var nowSeconds = now.getSeconds(); // 当前秒
    nowHours = checkTime(nowHours);
    nowMinutes = checkTime(nowMinutes);
    nowSeconds = checkTime(nowSeconds);
    return `${nowHours}:${nowMinutes}:${nowSeconds}`;
}

// 当前日期 带着时间
export function getCurrentMonthDay() {
    var now = new Date(); // 当前日期
    var nowYear = now.getFullYear();
    var nowDay = now.getDate(); // 当前日
    var nowMonth = now.getMonth() + 1; // 当前月
    nowMonth = checkTime(nowMonth);
    nowDay = checkTime(nowDay);
    var nowHours = now.getHours(); // 当前小时
    var nowMinutes = now.getMinutes(); // 当前分钟
    var nowSeconds = now.getSeconds(); // 当前秒
    nowHours = checkTime(nowHours);
    nowMinutes = checkTime(nowMinutes);
    nowSeconds = checkTime(nowSeconds);
    return `${nowYear}-${nowMonth}-${nowDay} ${nowHours}:${nowMinutes}:${nowSeconds}`;
}

// 当前日期 年月日
export function getCurrentMonthDay2() {
    var now = new Date(); // 当前日期
    var nowYear = now.getFullYear();
    var nowDay = now.getDate(); // 当前日
    var nowMonth = now.getMonth() + 1; // 当前月
    nowMonth = checkTime(nowMonth);
    nowDay = checkTime(nowDay);

    return `${nowYear}-${nowMonth}-${nowDay}`;
}

// 当前日期，星期几
export function getCurrentWeek() {
    var tempDate = new Date();

    var days = tempDate.getDay();
    var week;

    switch (days) {
        case 1:
            week = '星期一';
            break;
        case 2:
            week = '星期二';
            break;
        case 3:
            week = '星期三';
            break;
        case 4:
            week = '星期四';
            break;
        case 5:
            week = '星期五';
            break;
        case 6:
            week = '星期六';
            break;
        case 0:
            week = '星期日';
            break;
    }

    return week;
}

// 当前日期 年 月 日 时 分
export function getCurrentMonthDay3() {
    var now = new Date(); // 当前日期
    var nowYear = now.getFullYear();
    nowYear = String(nowYear).substring(2, 4);
    var nowDay = now.getDate(); // 当前日
    var nowMonth = now.getMonth() + 1; // 当前月
    nowMonth = checkTime(nowMonth);
    nowDay = checkTime(nowDay);
    var nowHours = now.getHours(); // 当前小时
    var nowMinutes = now.getMinutes(); // 当前分钟
    nowHours = checkTime(nowHours);
    nowMinutes = checkTime(nowMinutes);
    return `${nowYear}${nowMonth}${nowDay}${nowHours}${nowMinutes}`;
}

// 当前日期 年月
export function getCurrentMonthDay4() {
    var now = new Date(); // 当前日期
    var nowYear = now.getFullYear();
    var nowMonth = now.getMonth() + 1; // 当前月
    nowMonth = checkTime(nowMonth);

    return `${nowYear}-${nowMonth}`;
}

// 当前日期 年 月 日 时 分 秒
export function getCurrentMonthDay5() {
    var now = new Date() // 当前日期
    var nowYear = now.getFullYear()
    nowYear = String(nowYear).substring(2, 4)
    var nowDay = now.getDate() // 当前日
    var nowMonth = now.getMonth() + 1 // 当前月
    nowMonth = checkTime(nowMonth)
    nowDay = checkTime(nowDay)
    var nowHours = now.getHours() // 当前小时
    var nowMinutes = now.getMinutes() // 当前分钟
    nowHours = checkTime(nowHours)
    nowMinutes = checkTime(nowMinutes)
    var nowSeconds = now.getSeconds() // 当前秒
    nowSeconds = checkTime(nowSeconds)
    return `${nowYear}${nowMonth}${nowDay}${nowHours}${nowMinutes}${nowSeconds}`
}

const checkTime = (time) => {
    return time < 10 ? `0${time}` : time;
};

//日期格式化
export function formatDate(date, key) {
    if (key == 'yyyy-MM-dd') {
        let day = date.getDate()
        return `${date.getFullYear()}-${date.getMonth() + 1}-` + (day < 10 ? ('0' + String(day)) : String(day));
    } else if (key == 'yyyy-MM') {
        return `${date.getFullYear()}-${date.getMonth() + 1}`;
    } else {
        return `${date.getFullYear()}-${
            date.getMonth() + 1
        }-${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}
      `;
    }
};

// 表单重置
export function resetForm(refName) {
    if (this.$refs[refName]) {
        this.$refs[refName].resetFields();
    }
}

// 添加日期范围
export function addDateRange(params, dateRange, propName) {
    let search = params;
    search.params =
        typeof search.params === 'object' && search.params !== null && !Array.isArray(search.params)
            ? search.params
            : {};
    dateRange = Array.isArray(dateRange) ? dateRange : [];
    if (typeof propName === 'undefined') {
        search.params['beginTime'] = dateRange[0];
        search.params['endTime'] = dateRange[1];
    } else {
        search.params['begin' + propName] = dateRange[0];
        search.params['end' + propName] = dateRange[1];
    }
    return search;
}

// 回显数据字典
export function selectDictLabel(datas, value) {
    var actions = [];
    Object.keys(datas).some((key) => {
        if (datas[key].dictValue == '' + value) {
            actions.push(datas[key].dictLabel);
            return true;
        }
    });
    return actions.join('');
}

// 回显数据字典（字符串数组）
export function selectDictLabels(datas, value, separator) {
    var actions = [];
    var currentSeparator = undefined === separator ? ',' : separator;
    var temp = value.split(currentSeparator);
    Object.keys(value.split(currentSeparator)).some((val) => {
        Object.keys(datas).some((key) => {
            if (datas[key].dictValue == '' + temp[val]) {
                actions.push(datas[key].dictLabel + currentSeparator);
            }
        });
    });
    return actions.join('').substring(0, actions.join('').length - 1);
}

// 通用下载方法
export function download(fileName) {
    window.location.href =
        baseURL + '/common/download?fileName=' + encodeURI(fileName) + '&delete=' + true;
}

// 字符串格式化(%s )
export function sprintf(str) {
    var args = arguments,
        flag = true,
        i = 1;
    str = str.replace(/%s/g, function () {
        var arg = args[i++];
        if (typeof arg === 'undefined') {
            flag = false;
            return '';
        }
        return arg;
    });
    return flag ? str : '';
}

// 转换字符串，undefined,null等转化为""
export function praseStrEmpty(str) {
    if (!str || str == 'undefined' || str == 'null') {
        return '';
    }
    return str;
}

// 数据合并
export function mergeRecursive(source, target) {
    for (var p in target) {
        try {
            if (target[p].constructor == Object) {
                source[p] = mergeRecursive(source[p], target[p]);
            } else {
                source[p] = target[p];
            }
        } catch (e) {
            source[p] = target[p];
        }
    }
    return source;
}

/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 */
export function handleTree(data, id, parentId, children) {
    let config = {
        id: id || 'id',
        parentId: parentId || 'parentId',
        childrenList: children || 'children',
    };

    var childrenListMap = {};
    var nodeIds = {};
    var tree = [];

    for (let d of data) {
        let parentId = d[config.parentId];
        if (childrenListMap[parentId] == null) {
            childrenListMap[parentId] = [];
        }
        nodeIds[d[config.id]] = d;
        childrenListMap[parentId].push(d);
    }

    for (let d of data) {
        let parentId = d[config.parentId];
        if (nodeIds[parentId] == null) {
            tree.push(d);
        }
    }

    for (let t of tree) {
        adaptToChildrenList(t);
    }

    function adaptToChildrenList(o) {
        if (childrenListMap[o[config.id]] !== null) {
            o[config.childrenList] = childrenListMap[o[config.id]];
        }
        if (o[config.childrenList]) {
            for (let c of o[config.childrenList]) {
                adaptToChildrenList(c);
            }
        }
    }

    return tree;
}

/**
 * 参数处理
 * @param {*} params  参数
 */
export function tansParams(params) {
    let result = '';
    for (const propName of Object.keys(params)) {
        const value = params[propName];
        var part = encodeURIComponent(propName) + '=';
        if (value !== null && typeof value !== 'undefined') {
            if (typeof value === 'object') {
                for (const key of Object.keys(value)) {
                    if (value[key] !== null && typeof value[key] !== 'undefined') {
                        let params = propName + '[' + key + ']';
                        var subPart = encodeURIComponent(params) + '=';
                        result += subPart + encodeURIComponent(value[key]) + '&';
                    }
                }
            } else {
                result += part + encodeURIComponent(value) + '&';
            }
        }
    }
    return result;
}

// 精准计算乘法
export function accMul(arg1, arg2) {
    var m = 0,
        s1 = arg1 ? arg1.toString() : '0',
        s2 = arg2 ? arg2.toString() : '0';
    try {
        m += s1.split('.')[1].length;
    } catch (e) {
    }
    try {
        m += s2.split('.')[1].length;
    } catch (e) {
    }
    return (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) / Math.pow(10, m);
}

// 算总数量
export function calTotal(list, value) {
    let totalCount = 0;
    list.forEach((item) => {
        totalCount = +item[value] + totalCount;
    });
    return totalCount;
}

// 算总金额
export function handleTotalAmount(list, label1, value1, label2, value2) {
    // value1 指单价  value2 指数量
    let totalMoney = 0;
    let totalCount = 0;

    list.forEach((item) => {
        if (label1) {
            totalMoney += this.accMul(item[value1], item[value2]);
        }
        totalCount = value2 ? +item[value2] + totalCount : 0;
    });
    let arr = [];
    if (totalCount) {
        // value1 指总价   value2指总数
        arr = [
            {
                label1,
                value1: totalMoney === 0 ? null : totalMoney,
                label2,
                value2: totalCount,
            },
        ];
    } else {
        arr = [
            {
                label2,
                value2: totalCount,
            },
        ];
    }
    return arr;
}

//对象转为FormData
export function objectToFormData(obj, form, namespace) {
    const fd = form || new FormData();
    let formKey;

    for (var property in obj) {
        if (obj.hasOwnProperty(property)) {
            let key = Array.isArray(obj) ? '[]' : `[${property}]`;
            if (namespace) {
                formKey = namespace + key;
            } else {
                formKey = property;
            }

            // if the property is an object, but not a File, use recursivity.
            if (typeof obj[property] === 'object' && !(obj[property] instanceof File)) {
                objectToFormData(obj[property], fd, formKey);
            } else {
                // if it's a string or a File object
                fd.append(formKey, obj[property]);
            }
        }
    }

    return fd;
}

// js 根据经纬度计算两地之间的距离
export function space(lat1, lng1, lat2, lng2) {
    var radLat1 = (lat1 * Math.PI) / 180.0;
    var radLat2 = (lat2 * Math.PI) / 180.0;
    var a = radLat1 - radLat2;
    var b = (lng1 * Math.PI) / 180.0 - (lng2 * Math.PI) / 180.0;
    var s =
        2 *
        Math.asin(
            Math.sqrt(
                Math.pow(Math.sin(a / 2), 2) +
                Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)
            )
        );
    s = s * 6378.137;
    s = Math.round(s * 10000) / 10000;
    return s; // 单位千米
}

function rad(d) {
    return (d * Math.PI) / 180.0;
}

export function distanceOf(p1, p2) {
    var radLng1 = rad(p1.x);
    var radLng2 = rad(p2.x);
    var mdifference = radLng1 - radLng2;
    var difference = rad(p1.y) - rad(p2.y);
    var distance =
        2 *
        Math.asin(
            Math.sqrt(
                Math.pow(Math.sin(difference / 2), 2) +
                Math.cos(radLng1) * Math.cos(radLng2) * Math.pow(Math.sin(mdifference / 2), 2)
            )
        );
    distance = distance * 6378.137;
    distance = Math.abs(Math.round(distance * 10000) / 10);
    return distance;
}

// 方法定义 lat,lng
export function GetDistance(lat1, lng1, lat2, lng2) {
    var radLat1 = (lat1 * Math.PI) / 180.0;
    var radLat2 = (lat2 * Math.PI) / 180.0;
    var a = radLat1 - radLat2;
    var b = (lng1 * Math.PI) / 180.0 - (lng2 * Math.PI) / 180.0;
    var s =
        2 *
        Math.asin(
            Math.sqrt(
                Math.pow(Math.sin(a / 2), 2) +
                Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)
            )
        );
    s = s * 6378.137; // EARTH_RADIUS;
    s = Math.round(s * 10000) / 10; // 单位为米
    return s;
}

//数字转汉字大写
export function number_chinese(str) {
    var num = parseFloat(str)
    var strOutput = '',
        strUnit = '仟佰拾亿仟佰拾万仟佰拾元角分'
    num += '00'
    var intPos = num.indexOf('.')
    if (intPos >= 0) {
        num = num.substring(0, intPos) + num.substr(intPos + 1, 2)
    }
    strUnit = strUnit.substr(strUnit.length - num.length)
    for (var i = 0; i < num.length; i++) {
        strOutput += '零壹贰叁肆伍陆柒捌玖'.substr(num.substr(i, 1), 1) + strUnit.substr(i, 1)
    }
    return strOutput.replace(/零角零分$/, '整').replace(/零[仟佰拾]/g, '零').replace(/零{2,}/g, '零').replace(/零([亿|万])/g, '$1').replace(/零+元/, '元').replace(/亿零{0,3}万/, '亿').replace(/^元/, '零元')
}

//字符串转换为十六进制
export function stringToHex(str) {
    let val = ''
    for (let i = 0; i < str.length; i++) {
        if (val == '') {
            val = str.charCodeAt(i).toString(16)
        } else {
            val += ',' + str.charCodeAt(i).toString(16)
        }
    }
    return val
}

//十六进制转换为字符串
export function hexToString(str) {
    let val = ''
    let arr = str.split(',')
    for (let i = 0; i < arr.length; i++) {
        val += String.fromCharCode(parseInt(arr[i],16));
    }
    return val
}
